import { RADashboardCardId, RAReportDataSource } from './cards-enums'
import { RADashboardTabId } from './tab-enums'

export const TabSourceLookup: Record<RADashboardTabId, RAReportDataSource[]> = {
  [RADashboardTabId.Overview]: [],
  [RADashboardTabId.FactorLens]: [],
  [RADashboardTabId.Holdings]: [RAReportDataSource.HoldingsSecurityDetails],
}

export const CardSourceLookup: Record<RADashboardCardId, RAReportDataSource[]> = Object.freeze({
  [RADashboardCardId.FactorLensRisk]: [RAReportDataSource.FactorLens],
  // Split-out Factor Lens cards — reuse the existing FactorLens source.
  [RADashboardCardId.FactorLensGridRisk]: [RAReportDataSource.FactorLens],
  [RADashboardCardId.FactorWaterfallRisk]: [RAReportDataSource.FactorLens],
  [RADashboardCardId.FactorBreakdownRisk]: [RAReportDataSource.FactorLens],
  [RADashboardCardId.MetricsSummaryRisk]: [RAReportDataSource.RiskMetricsSummary],
  [RADashboardCardId.HoldingsContributionRisk]: [RAReportDataSource.HoldingsSecurityDetails],
  [RADashboardCardId.Point_DV01]: [RAReportDataSource.PortItemDV01],
  [RADashboardCardId.Point_Duration]: [RAReportDataSource.PortItemEffectiveDuration],
  [RADashboardCardId.Point_Convexity]: [RAReportDataSource.PortItemConvexity],
  [RADashboardCardId.Point_YieldToMaturity]: [RAReportDataSource.PortItemYieldToMaturity],
  [RADashboardCardId.Point_SpreadDuration]: [RAReportDataSource.PortItemSpreadDuration],
  [RADashboardCardId.Point_YearsToMaturity]: [RAReportDataSource.PortItemYearsToMaturity],
  [RADashboardCardId.Point_YieldToWorst]: [RAReportDataSource.PortItemYieldToWorst],
  [RADashboardCardId.Point_CouponRate]: [RAReportDataSource.PortItemCouponRate],
  [RADashboardCardId.Point_DividendYield]: [RAReportDataSource.PortItemDividendYield],
  [RADashboardCardId.Point_AverageLife]: [RAReportDataSource.PortItemAverageLife],
  [RADashboardCardId.Point_Beta]: [RAReportDataSource.PortItemBeta],
  [RADashboardCardId.Point_BookToPrice]: [RAReportDataSource.PortItemBookToPrice],
  [RADashboardCardId.Point_BookValue]: [RAReportDataSource.PortItemBookValue],
  [RADashboardCardId.Point_CashFlowYield]: [RAReportDataSource.PortItemCashFlowYield],
  [RADashboardCardId.Point_CurrentYield]: [RAReportDataSource.PortItemCurrentYield],
  [RADashboardCardId.Point_EPRatio]: [RAReportDataSource.PortItemEPRatio],
  [RADashboardCardId.Point_EarningsPerShare]: [RAReportDataSource.PortItemEarningsPerShare],
  [RADashboardCardId.Point_EffectiveD2]: [RAReportDataSource.PortItemEffectiveD2],
  [RADashboardCardId.Point_EffectiveD3]: [RAReportDataSource.PortItemEffectiveD3],
  [RADashboardCardId.Point_DurContributionPct]: [RAReportDataSource.PortItemDurContributionPct],
  [RADashboardCardId.Point_DurContributionYrs]: [RAReportDataSource.PortItemDurContributionYrs],
  [RADashboardCardId.Point_EffectiveSpreadDuration]: [RAReportDataSource.PortItemEffectiveSpreadDuration],
  [RADashboardCardId.Point_SpreadDurContributionPct]: [RAReportDataSource.PortItemSpreadDurContributionPct],
  [RADashboardCardId.Point_SpreadDurContributionYrs]: [RAReportDataSource.PortItemSpreadDurContributionYrs],
  [RADashboardCardId.Point_GainLoss]: [RAReportDataSource.PortItemGainLoss],
  [RADashboardCardId.Point_MacaulayDuration]: [RAReportDataSource.PortItemMacaulayDuration],
  [RADashboardCardId.Point_MarketCap]: [RAReportDataSource.PortItemMarketCap],
  [RADashboardCardId.Point_MarketCapLog]: [RAReportDataSource.PortItemMarketCapLog],
  [RADashboardCardId.Point_MarketValue]: [RAReportDataSource.PortItemMarketValue],
  [RADashboardCardId.Point_MarketValuePar]: [RAReportDataSource.PortItemMarketValuePar],
  [RADashboardCardId.Point_ModifiedDuration]: [RAReportDataSource.PortItemModifiedDuration],
  [RADashboardCardId.Point_Momentum]: [RAReportDataSource.PortItemMomentum],
  [RADashboardCardId.Point_MoodyQuality]: [RAReportDataSource.PortItemMoodyQuality],
  [RADashboardCardId.Point_NotionalValue]: [RAReportDataSource.PortItemNotionalValue],
  [RADashboardCardId.Point_OAS]: [RAReportDataSource.PortItemOAS],
  [RADashboardCardId.Point_PBRatio]: [RAReportDataSource.PortItemPBRatio],
  [RADashboardCardId.Point_PERatio]: [RAReportDataSource.PortItemPERatio],
  [RADashboardCardId.Point_PctFaceMarketValue]: [RAReportDataSource.PortItemPctFaceMarketValue],
  [RADashboardCardId.Point_PctMarketValue]: [RAReportDataSource.PortItemPctMarketValue],
  [RADashboardCardId.Point_Price]: [RAReportDataSource.PortItemPrice],
  [RADashboardCardId.Point_SPQuality]: [RAReportDataSource.PortItemSPQuality],
  [RADashboardCardId.Point_SecurityCount]: [RAReportDataSource.PortItemSecurityCount],
  [RADashboardCardId.Point_TotalAccruedInterest]: [RAReportDataSource.PortItemTotalAccruedInterest],
  [RADashboardCardId.Point_TrailingEPS]: [RAReportDataSource.PortItemTrailingEPS],
  [RADashboardCardId.Point_Volatility]: [RAReportDataSource.PortItemVolatility],
  [RADashboardCardId.Point_YearsToWorst]: [RAReportDataSource.PortItemYearsToWorst],
  // End extended data point cards
  [RADashboardCardId.Point_TrailingRisk]: [RAReportDataSource.RiskOneYearHistory],
  [RADashboardCardId.HoldingsTopBottom]: [],
  [RADashboardCardId.HoldingsRiskVisualization]: [],
  // Factor Attribution Cards
  [RADashboardCardId.Return_Portfolio]: [RAReportDataSource.TotalReturns],
  [RADashboardCardId.Return_Benchmark]: [RAReportDataSource.TotalReturns],
  [RADashboardCardId.Return_Active]: [RAReportDataSource.TotalReturns],
  [RADashboardCardId.Chart_DailyReturn]: [RAReportDataSource.DailySummaries],
  // Portfolio/Benchmark/Active Return: totalReturn value + a daily-summaries sparkline.
  [RADashboardCardId.Chart_PortfolioReturn]: [RAReportDataSource.TotalReturns, RAReportDataSource.DailySummaries],
  [RADashboardCardId.Chart_BenchmarkReturn]: [RAReportDataSource.TotalReturns, RAReportDataSource.DailySummaries],
  [RADashboardCardId.Chart_ActiveReturn]: [RAReportDataSource.TotalReturns, RAReportDataSource.DailySummaries],
  // Factor Attribution bar chart — per-period factor contribution.
  [RADashboardCardId.Chart_FactorAttribution]: [RAReportDataSource.FactorContributionFreq, RAReportDataSource.FactorContributionTotal],
  [RADashboardCardId.Table_Holdings]: [RAReportDataSource.SecurityContribution],
  [RADashboardCardId.Table_HoldingsTopBottom]: [RAReportDataSource.SecurityContribution],
  [RADashboardCardId.Chart_HoldingsBubble]: [RAReportDataSource.SecurityContribution],
})

export default CardSourceLookup

export function lookupCardSources(cardId: RADashboardCardId) {
  return CardSourceLookup[cardId] ?? []
}
export function lookupTabSources(tabId: RADashboardTabId) {
  return TabSourceLookup[tabId] ?? []
}
